// extracted by mini-css-extract-plugin
export default {"hide":"qr-code-image_hide__4pqF1","qrCodeWrapper":"qr-code-image_qrCodeWrapper__fE4xs","copyButton":"qr-code-image_copyButton__ZOCss"};